// Port of api/fuel/app/classes/insights/players/newcomers.php

import Segment from 'offline/insights/segment'
import Constants from 'offline/constants'
import Util from 'offline/util'

export default Segment.extend({
	name: 'newcomers',
	requires: ['init'],
	types: [Constants.TYPE_USER],
	insight: false,
	detail: ['newcomers'],
	run: function(type, owner, userIndex, detail) {
		var list = []
		var players = (this._data.players || []).filter(function(player) {
			return player.dateFirst > 0
		})
		var limit = detail ? 250 : 5

		players = players.slice().sort(function(a, b) {
			var av = parseInt(a.dateFirst, 10) || 0
			var bv = parseInt(b.dateFirst, 10) || 0
			if (av !== bv) return bv - av
			return String(a.slug || '').localeCompare(String(b.slug || ''))
		})
		if (players.length > limit) players = players.slice(0, limit)

		for (var i = 0; i < players.length; i++) {
			list.push({
				id: parseInt(players[i].id, 10) || 0,
				slug: players[i].slug,
				name: players[i].primaryName,
				username: players[i].username,
				game: parseInt(players[i].gameFirst, 10) || 0,
				date: parseInt(players[i].dateFirst, 10) || 0,
				d: parseInt(players[i].dateFirst, 10) || 0
			})
			if (players[i].id) this._references.users.push(parseInt(players[i].id, 10))
			this._references.games.push(parseInt(players[i].gameFirst, 10) || 0)
		}

		return {
			newcomers: list
		}
	}
})
